export default {
  label: {
    title: 'Access to the dashboard',
    button: {
      cancelButton: 'Cancel',
      confirmButton: 'Access',
    },
    form: {
      title: 'E-mail *',
      agreeTerms: {
        messageFirstPart: 'I have read and accept the ',
        messageSecondPart: ' and the',
        useTerms: 'Terms of Use',

        privacyPolicy: 'Privacy Policy',
      },
      error: {
        addEmail: 'E-mail is required.',
      },
    },
  },
};
